import React, { useState } from 'react';

const CreateStorePopup = ({ onClose, onCreate }) => {
  const [storeName, setStoreName] = useState('');

  const handleSubmit = () => {
    if (!storeName.trim()) {
      alert('Please enter a store name.');
      return;
    }
    onCreate(storeName);
    onClose();
  };

  const isCreateDisabled = !storeName.trim(); // Disable if storeName is empty after trimming

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          width: '400px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        }}
      >
        <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
          Create New Store
        </h3>
        <p style={{ color: '#666', marginBottom: '20px' }}>
          Enter a name for your new store.
        </p>
        <input
          type="text"
          placeholder="Store Name"
          value={storeName}
          onChange={(e) => setStoreName(e.target.value)}
          style={{
            width: '100%',
            padding: '10px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            fontSize: '14px',
            marginBottom: '20px',
            boxSizing: 'border-box',
          }}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button
            onClick={onClose}
            style={{
              padding: '8px 16px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              background: 'white',
              color: '#333',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={isCreateDisabled}
            style={{
              padding: '8px 16px',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: isCreateDisabled ? '#cccccc' : '#4A90E2',
              color: 'white',
              cursor: isCreateDisabled ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              opacity: isCreateDisabled ? 0.6 : 1,
            }}
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateStorePopup;